import { createRoot } from 'react-dom/client';
import React from 'react';

/**
 * For each provided react component check if there is an item in the
 * dom which refers to this component. If so render the component.
 *
 * Pass the properties set in the html as props to the component.
 *
 * @Example
 * <app-scroll-top-component></app-scroll-top-component>
 * <app-checkout></app-checkout>
 */
export function registerReactComponents (components: { component: any; selector: string }[]): void {
  components
    .filter(({ selector }) => $(selector).length)
    .forEach(({ component, selector }) => {
      // Search for the component selector in the dom.
      $(selector).each((index: number, element: HTMLElement): void => {
        // Get the html attributes.
        const atts: NamedNodeMap = element.attributes;
        const props: { [key: string]: string } = {};

        // Loop over the attributes map
        Array
          .from({ length: atts.length })
          .map((item, i: number) => props[atts[i].nodeName] = atts[i].nodeValue);

        // Generate the component for each item found on the page and set the index as prop.
        createRoot(element).render(
          React.createElement(component, { index: index, ...props })
        );
      });
    });
}
